
export const serviceChannelUploadEditColumnDef = [
  { "headerName": "Errors", "field": "errors", filter: 'agTextColumnFilter' },
  { "headerName": "Order No", "field": "orderNo", filter: 'agTextColumnFilter' },
  { "headerName": "Order Date", "field": "orderDate", filter: 'agTextColumnFilter' },
  { "headerName": "Premium Type", "field": "premiumType", filter: 'agTextColumnFilter' },
  { "headerName": "Payment No", "field": "paymentNo", filter: 'agTextColumnFilter' },
  { "headerName": "Brokrage Type", "field": "brokrageType", filter: 'agTextColumnFilter' },
  { "headerName": "Ref Percentage", "field": "refPercentage", filter: 'agTextColumnFilter' },
  { "headerName": "Payment Approved By", "field": "paymentApprovedBy", filter: 'agTextColumnFilter' },
  { "headerName": "Tax Type", "field": "taxType", filter: 'agTextColumnFilter' },
  { "headerName": "Tax Percentage", "field": "taxPercentage", filter: 'agTextColumnFilter' },
  { "headerName": "Payment Date", "field": "paymentDate", filter: 'agTextColumnFilter' },
  { "headerName": "Payment Mode", "field": "paymentMode", filter: 'agTextColumnFilter' },
  { "headerName": "Bank", "field": "bank", filter: 'agTextColumnFilter' },
  { "headerName": "Branch", "field": "branch", filter: 'agTextColumnFilter' },
  { "headerName": "RefNo", "field": "refNo", filter: 'agTextColumnFilter' },
  { "headerName": "RefAmountPaid", "field": "refAmountPaid", filter: 'agTextColumnFilter' },
  
  
  	
  	
  
]
